var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShortsFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "m17.77 10.32-1.2-.5L18 9.06A3.724 3.724 0 0 0 19.559 4a3.75 3.75 0 0 0-5.07-1.559L6 6.941a3.743 3.743 0 0 0-2 3.489 3.76 3.76 0 0 0 2.219 3.25c.031.011 1.203.5 1.203.5L6 14.93a3.75 3.75 0 1 0 3.512 6.629l8.5-4.5A3.733 3.733 0 0 0 20 13.57a3.762 3.762 0 0 0-2.23-3.25zM10 14.648V9.352L15 12zm0 0"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortsFilled);
export default __webpack_public_path__ + "static/media/shorts_filled.354fd19d824ae3082f9c428e62ce00a7.svg";
export { ForwardRef as ReactComponent };